import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=1b3c125c&scoped=true&"
import script from "./Slogan.vue?vue&type=script&lang=ts&"
export * from "./Slogan.vue?vue&type=script&lang=ts&"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=1b3c125c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c125c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
